(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('fixed-top');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('searchModal');     
    }
  }

  customElements.define('sticky-header', StickyHeader);



  var wdtHeaderMenu = document.querySelector('.dt-desktop-menu');
  var wdtDesktopHover = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');

  if (wdtHeaderMenu && wdtDesktopHover.matches) {
    wdtHeaderMenu.querySelectorAll(':scope > .nav-item').forEach(function(wdtItem) {
      var wdtToggle = wdtItem.querySelector(':scope > .dropdown-toggle, :scope > .mega-menu__wrapper > .dropdown-toggle');

      if (!wdtToggle) return;

      var wdtDropdownMenu = wdtToggle.nextElementSibling;
      var wdtCloseTimer;
      var wdtClickPinned = false;

      if (!wdtDropdownMenu || !wdtDropdownMenu.classList.contains('dropdown-menu')) return;

      function wdtOpenDropdown() {
        window.clearTimeout(wdtCloseTimer);
        wdtItem.classList.add('is-hover-open');
        wdtDropdownMenu.setAttribute('data-bs-popper', 'static');
        wdtToggle.classList.add('show');
        wdtToggle.setAttribute('aria-expanded', 'true');
        wdtDropdownMenu.classList.add('show');
      }

      function wdtCloseDropdown(wdtForceClose) {
        window.clearTimeout(wdtCloseTimer);
        if (wdtClickPinned && !wdtForceClose) return;

        wdtCloseTimer = window.setTimeout(function() {
          if (wdtClickPinned && !wdtForceClose) return;

          wdtItem.classList.remove('is-hover-open');
          wdtDropdownMenu.removeAttribute('data-bs-popper');
          wdtToggle.classList.remove('show');
          wdtToggle.setAttribute('aria-expanded', 'false');
          wdtDropdownMenu.classList.remove('show');
        }, wdtForceClose ? 0 : 400);
      }

      wdtItem.addEventListener('mouseenter', wdtOpenDropdown);
      wdtItem.addEventListener('mouseleave', function() {
        wdtCloseDropdown();
      });
      wdtItem.addEventListener('focusin', wdtOpenDropdown);
      wdtItem.addEventListener('focusout', function(event) {
        if (!wdtItem.contains(event.relatedTarget)) wdtCloseDropdown();
      });

      wdtToggle.addEventListener('click', function() {
        wdtClickPinned = !wdtClickPinned;

        window.setTimeout(function() {
          if (wdtClickPinned) {
            wdtOpenDropdown();
          } else {
            wdtCloseDropdown(true);
          }
        }, 0);
      });

      wdtItem.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape') return;

        wdtClickPinned = false;
        wdtCloseDropdown(true);
      });

      document.addEventListener('click', function(event) {
        if (wdtItem.contains(event.target)) return;

        wdtClickPinned = false;
        wdtCloseDropdown(true);
      });
    });
  }

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('show.bs.tab', (event) => {
    const tab = event.target.closest('[data-bs-toggle="tab"]');
    const section = tab?.closest('[data-product-tabs]');
    const target = tab?.getAttribute('href');
    if (!section || !target?.startsWith('#')) return;
    const panel = document.getElementById(target.slice(1));
    if (panel?.closest('[data-product-tabs]') !== section) return;
    const template = panel.querySelector('template[data-product-tab-content]');
    if (template) {
      template.replaceWith(template.content);
      panel.dispatchEvent(new CustomEvent('iglam:products-rendered', { bubbles: true }));
    }
  });

  document.addEventListener('shown.bs.tab', (event) => {
    if (event.target.closest('[data-product-tabs]')) window.AOS?.refreshHard();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const moveMoreProductsLikeThis = () => {
    const recommendations = document.querySelector('[data-more-products-like-this]');
    const mount = document.querySelector('[data-more-products-like-this-mount]');

    if (recommendations && mount && recommendations.parentElement !== mount) {
      mount.append(recommendations);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveMoreProductsLikeThis, { once: true });
  } else {
    moveMoreProductsLikeThis();
  }

  document.addEventListener('shopify:section:load', moveMoreProductsLikeThis);

  } catch(e) { console.error(e); }
})();
})();
